import { Link } from "@tanstack/react-router";
import type { ScopeTab } from "./model";

/** Переключатель режима «все / когорты / без когорты» — ссылки на /mentor/cohort/{scope}.
 *  Счётчики — из /admin/cohorts, не строкой. */
export function ScopeTabs({ tabs, value }: { tabs: ScopeTab[]; value: string }) {
  return (
    <nav aria-label="режим" className="inline-flex flex-wrap gap-[3px] rounded-sm border border-bd p-[3px]" data-testid="scope-tabs">
      {tabs.map((t) => {
        const on = t.id === value;
        return (
          <Link
            key={t.id}
            to="/mentor/cohort/$scope"
            params={{ scope: t.id }}
            aria-current={on ? "page" : undefined}
            data-testid={`scope-${t.id}`}
            className={`inline-flex items-baseline gap-1.5 rounded-[3px] px-2.5 py-1 font-mono text-[11.5px] leading-none no-underline ${on ? "bg-accsoft text-acc" : "text-mut hover:text-ink"}`}
          >
            {t.label}
            <span className={on ? "text-acc" : "text-mut"}>{t.count}</span>
          </Link>
        );
      })}
    </nav>
  );
}
